export const DELAY_RENDERED_COMPONENT_CHECKING_MS = 1000;

export const SENTRY_DEV_ENV = 'development';
